import { createSelector } from 'reselect';
import { RootState } from '../../store/store';

// Селекторы для получения состояния Redux
const isLoadingSelector = (state: RootState) => state.app.loading;
const isloggedSelector = (state: RootState) => state.app.logged;

// Создание селекторов
export const selectIsLoadingApp = createSelector(isLoadingSelector, isLoading => isLoading);
export const selectIsLoggedApp = createSelector(isloggedSelector, isLoggedIn => isLoggedIn);
